import { render } from "./HomeNews.vue?vue&type=template&id=97cb59fc&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=97cb59fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cb59fc"]])

export default __exports__